import React, { useEffect, useRef } from 'react';

import memoizeOne from 'memoize-one';

import { Navigate, useLocation } from 'react-router-dom';

import window from 'window-or-global';

import { __ADMIN__ } from '@vz/env';

import { useSWR } from '../../hooks/useSWR';
import { scrollIntoView, getScrollParent } from '../../helpers/dom';

import { Link } from '../Link';
import Spinner from '../Spinner';

import S from './BlogList.module.css';
import { LinkEdit } from '../Link/LinkEdit';

import Sa from './Admin.module.css';
import { AddButton } from '../Admin/AddButton';

const groupByYear = memoizeOne((data) =>
  data.reduce((memo, item) => {
    const YYYY = parseInt(item.date.published.split('-')[0], 10);
    if (!memo[YYYY]) {
      memo[YYYY] = [];
    }
    memo[YYYY].push(item);
    return memo;
  }, {})
);

export const BlogList = () => {
  const { pathname } = useLocation();

  const reqURL = '/data/posts.json'; //'/api/blog-list';

  const {
    data: apiResponse,
    error,
    isLoading
  } = useSWR(reqURL, {
    initial: window.__INITIAL_DATA__?.[reqURL]
  });

  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!rootRef.current) {
      return;
    }
    const el = rootRef.current.querySelector('[data-active="true"]');
    scrollIntoView({ el, parent: getScrollParent(rootRef.current) });
  }, [rootRef.current]);

  const data = apiResponse?.data;

  if (isLoading && !data) {
    return <Spinner size={24} className={S.spinner} />;
  }

  if (error && (!data || data?.length === 0)) {
    return <>...error: {error.message}</>;
  }

  const groupedData = groupByYear(data);

  const redirectTo =
    pathname !== '/blog'
      ? null
      : apiResponse.data.filter((item) => item.published !== 0)[0]?.url ||
        apiResponse.data[0]?.url;

  return (
    <>
      {redirectTo && <Navigate to={`/blog/${redirectTo}`} replace />}
      {/* {__ADMIN__ && (
        <AddButton
          api="/api/admin/blog/add"
          goto="/blog/edit/{{id}}"
          refreshApi="/api/blog-list"
          className={Sa.add}
        />
      )} */}
      <div className={S.root} ref={rootRef}>
        {Object.keys(groupedData)
          .sort()
          .reverse()
          .map((YYYY, idxUl) => (
            <React.Fragment key={idxUl}>
              <div className={S.year}>{YYYY}</div>
              <ul key={idxUl} className={S.ul}>
                {groupedData[YYYY].map((item, idxLi) => (
                  <li
                    key={idxLi}
                    className={S.li}
                    data-published={item.published === true && undefined}
                  >
                    <Link
                      to={`/blog/${item.url}`}
                      className={S.link}
                      id={item.id}
                    >
                      <span className={S.title}>{item.title}</span>
                    </Link>
                    {/* {__ADMIN__ && (
                      <LinkEdit
                        to={`/blog/edit/${item.id}`}
                        className={S.edit}
                      />
                    )} */}
                  </li>
                ))}
              </ul>
            </React.Fragment>
          ))}
      </div>
    </>
  );
};
